module.exports = __webpack_public_path__ + "static/media/project_config_active.25c87970.svg";